import {Button, Stack, Typography} from '@mui/material';
import {IconIllustration} from 'presentation/components';
import {translations} from 'presentation/translations-new';
import React from 'react';
import {TutorialStepsId} from '../FavoriteAddressTutorials/constants';

const {
	emptyState: {title, description, action},
} = translations['pt-br'].privateFlow.profile.changeData.addresses;

export function EmptyState({
	handleAddNewAddress,
	showButton,
}: {
	handleAddNewAddress: () => void;
	showButton: boolean;
}) {
	return (
		<Stack
			gap={2}
			alignItems="center"
			mt={4}
			id={TutorialStepsId.EMPTY_STATE_ADD_BUTTON}
			sx={{width: 'max-content', margin: '32px auto'}}>
			<IconIllustration variant="default" customIconName="map" width={80} />
			<Stack alignItems="center" gap={1}>
				<Typography variant="h6" textAlign="center" color="textPrimary">
					{title}
				</Typography>
				<Typography variant="body1" textAlign="center" color="textSecondary" width="90%">
					{description}
				</Typography>
			</Stack>
			{showButton && (
				<Button variant="outlined" size="medium" onClick={handleAddNewAddress}>
					{action}
				</Button>
			)}
		</Stack>
	);
}
